<div class="container">
  <h1 class="title">À la une</h1>
  <p>TODO</p>
</div>
